import { useCertificationProfileExpiredTableStore } from '../../store/myTeamTableStateStore';
import CertificationProfileFilters from '../filters/CertificationProfileFilters';
import CertificationProfileExpiredTable from './CertificationProfileExpiredTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationProfileExpiredTab = () => {
  const store = useCertificationProfileExpiredTableStore();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CertificationProfileFilters, {
      store: store
    }), /*#__PURE__*/_jsx(CertificationProfileExpiredTable, {})]
  });
};
export default CertificationProfileExpiredTab;